module.exports = __webpack_public_path__ + "img/wc1.a4da38c9.png";